// extracted by mini-css-extract-plugin
module.exports = {"stale":"status_stale__3-I9N","active":"status_active__16GVe"};